import { render, staticRenderFns } from "./_desktopplate.vue?vue&type=template&id=ab260756&scoped=true"
import script from "./_desktopplate.vue?vue&type=script&lang=js"
export * from "./_desktopplate.vue?vue&type=script&lang=js"
import style0 from "./_desktopplate.vue?vue&type=style&index=0&id=ab260756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab260756",
  null
  
)

export default component.exports